import React, { useState, useEffect } from 'react';
import CategorySection from '../components/CategorySection';
import '../../style/components/FormView.css';

const Arrears = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  const nonAgriculturalTeachingLinks = [
    { href: "/daArrearsForm", text: "D.A. Arrears" },
    { href: "/arrearesSeventh", text: "Seventh Pay Arrears" }
  ];

  return (
    <div className={`FormView ${isLoading ? 'is-loading' : ''}`}>
      {isLoading ? (
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <div className="loading-text">Loading Resources...</div>
        </div>
      ) : (
        <>
          <h1 className="page-title">Arrears</h1>
          <div className="section-container">
            <CategorySection 
              title="Seventh Pay"
              links={nonAgriculturalTeachingLinks}
            />
            <div className="divider"></div>
          </div>
        </>
      )}
    </div>
  );
};

export default Arrears;